import { createSelector } from 'reselect';
import { ICognitoDomain } from './model';

export const domainSelector = (state: any): ICognitoDomain => state.cognito;

export const callWelcomeServerErrorMessageSelector = createSelector(
  domainSelector,
  (domain: ICognitoDomain) => domain.request.callWelcomeServerErrorMessage
);
